import styled from '@emotion/styled';
import { FormControlLabel, FormLabel, Radio } from '@mui/material';

export const StyledRadioButton = styled(FormLabel)`
  font-size: 1rem;
  color: #000000 !important;
  margin-bottom: 8px;
  text-align: left;
  .Mui-error {
    color: #d32f2f;
    font-size: 14px;
  }
`;

export const CustomFormControlLabel = styled(FormControlLabel)({
  '.MuiTypography-root': {
    color: '#344563' // Text color for labels
  }
});

export const CustomRadio = styled((props) => <Radio {...props} disableRipple />)({
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '& .MuiSvgIcon-root': {
    fontSize: 28, // Adjust the size of the radio icon if needed
    borderRadius: '50%', // Make sure the border is circular
    border: '2px solid transparent', // Green border for checked state
    backgroundColor: 'transparent' // Green outer circle
  },
  '&.Mui-checked': {
    color: '#000' // Black inner circle when checked
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    backgroundColor: '#A6CE39', // Green outer circle remains when checked
    borderColor: '#A6CE39' // Keeps the green border when checked
  }
});
